module.exports = __webpack_public_path__ + "static/media/icon_cross_light.1bde8e85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_cross_light.svg
// module id = 1220
// module chunks = 0